import React from 'react';
import IntlProvider from './intlProvider';
import ReactDOM from 'react-dom';
import store from './store';
import { Provider } from 'react-redux';
import 'react-quill/dist/quill.snow.css';

import './content/styles/bootstrap.scss';
import './index.css';
import './content/styles/custome.scss';
// import async.js
ReactDOM.render(
  <Provider store={store}>
    <IntlProvider store={store} />
  </Provider>,
  document.getElementById('root'),
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceworker.js').then(
      (registration) => {
        console.log(
          'Service Worker registered with scope:',
          registration.scope,
        );
      },
      (err) => {
        console.error('Service Worker registration failed:', err);
      },
    );
  });
}
